// import React from "react";
// import "./App.css";
// import CookieBanner from "./components/CookieBanner/CookieBanner";
// import Header from "./components/Header/Header";
// import Hero from "./components/Hero/Hero";
// import Services from "./components/Services/Services";
// import AboutUs from "./components/WhatWeDo/WhatWeDo";
// import WhyBest from "./components/WhyBest/WhyBest";
// import Team from "./components/Team/Team";
// import Footer from "./components/Footer/Footer";

// function App() {
//   return (
//     <div className="App">
//       <CookieBanner />
//       <Header />
//       <Hero />
//       <AboutUs />
//       <Services />

//       {/* <WhyBest /> */}
//       {/* <Team /> */}
//       <Footer />
//     </div>
//   );
// }

// export default App;

import React from "react";
import "./App.css";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Services from "./components/Services/Services";
import AboutUs from "./components/WhatWeDo/WhatWeDo";
import Packages from "./components/Packages/Packages";
import WhyBest from "./components/WhyBest/WhyBest";
import Team from "./components/Team/Team";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <CookieBanner />
      <Header />
      <Hero />
      <AboutUs />
      <Services />
      <Packages />
      {/* <WhyBest /> */}
      {/* <Team /> */}
      <Footer />
    </div>
  );
}

export default App;
